import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import AlertBox from "../layout/alertBox";

const MainWrapper = ({children}) => {
    // Select alerts from Redux state
    const alerts = useSelector((state) => state.alertReducer || []);

    // Memoize alerts rendering to prevent unnecessary re-renders
    const renderedAlerts = useMemo(() => 
        alerts.map((alertContent, index) => (<AlertBox key={`alert-${index}`} content={alertContent}/>)), [alerts]
   );
  
    return (
        <div className="site-layout-content">
            {renderedAlerts}
            {children}
        </div>
    )
}

export default MainWrapper;